export class GetPublicMembersRequest {
    constructor(ipp: number, p: number, st: string) {
        this.itemsPerPage = ipp;
        this.page = p;
        this.searchText = st;
    }
    itemsPerPage: number;
    page: number;
    searchText: string
}
